// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SignIn: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 26"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M26.25 26c.492 0 .908-.166 1.244-.502A1.66 1.66 0 0028 24.267V1.733a1.66 1.66 0 00-.506-1.231A1.692 1.692 0 0026.25 0H7v3.467h17.5v19.066H7V26h19.25zm-14-5.2v-5.2H0v-5.2h12.25V5.2l7.875 7.8-7.875 7.8z"
            />
        </svg>
    );
};

export default React.memo(SignIn);
